export default __webpack_public_path__ + "static/media/average.fa6062b2.svg";